import React, { Component } from 'react'

import favService from '../../Util/FavSDK'
import { openWindow } from '../../Util'

import './index.css'

favService.init('aplatform')

const _parseShoppingList = list => {
  return Promise.all(list.map(item => {
    item.flyToStartPoint = false
    if (item.type === 'ANCHOR') {
      item.flyToStartPoint = true
    }
    return new Promise((resolve, reject) => {
      favService.isFavoriteItem(item.itemId, ({ data = {} } = {}) => {
        let { isFavorite } = data
        if (true === isFavorite || 'true' === isFavorite) {
          item.collected = true
        }
        resolve(item)
      }, err => {
        resolve(item)
      })
    })
  }))
}

class ShoppingList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      list: [],
      animateCls: '',
      isAnimation: false,
      display: 'block',
      activeCls: ''
    }

    this.touchStartX = 0
    this.touchEndX = 0
    
    this.goDetail = this.goDetail.bind(this)
    this.handleTagClk = this.handleTagClk.bind(this)
    this.handleCollectClk = this.handleCollectClk.bind(this)
    this.handleOpenClk = this.handleOpenClk.bind(this)
    this.handleCloseClk = this.handleCloseClk.bind(this)
    this.handleTouchStart = this.handleTouchStart.bind(this)
    this.handleTouchMove = this.handleTouchMove.bind(this)
    this.handleTouchEnd = this.handleTouchEnd.bind(this)
  }

  /* componentWillReceiveProps(props) {
  } */

  componentDidMount() {
    const { shoppingList } = this.props
    console.log('componentWillReceiveProps')
    _parseShoppingList(shoppingList).then(list => {
      this.setState({ list })
    })
  }


  _showOrHide(type) {
    return new Promise((resolve, reject) => {
      this.setState({
        isAnimation: true,
        animateCls: type === 'show' ? 'fadeIn': 'fadeOut',
        display:  'block'
      })

      clearTimeout(this.timer)
      this.timer = setTimeout(e => {
        this.setState({
          animateCls: '',
          isAnimation: false,
          display: type === 'show' ? 'block': 'none'
        })
        resolve(type)
      }, 500)
    })
  }

  show() {
    return this._showOrHide('show')
  }

  hide() {
    return this._showOrHide('hide')
  }

  goDetail({ itemId }) {
    openWindow(`http://h5.m.taobao.com/awp/core/detail.htm?id=${itemId}`)
  }

  handleTagClk(e, item) {
    e.stopPropagation()
    let { tagId } = item
    const { locateHotspot } = this.props
      this.handleCloseClk().then(() => locateHotspot(tagId, item))
    // if (flyToStartPoint) {
    //   // flytostart
    //   let { locationId } = startLocation
    //   let floorMarkerRoot = controls.scene.getObjectByName('floorMarkerRoot')
    //   let floorMarker = floorMarkerRoot.getObjectByProperty('panorama', controls.panoramaCollection.atUUID(locationId))
    //   this.handleCloseClk().then(() => controls.flyToFloorMarker(floorMarker))
    //   return
    // }
    // if (tagId) {
    //   let tagRoot = controls.scene.getObjectByName('tagRoot')
    //   let tag = tagRoot.getObjectByProperty('tagId', tagId)
    //   let tagChild = tag.getObjectByName('tagIcon')
    //   this.handleCloseClk(true).then(() => controls.flyInFrontOfTag(tagChild))
    // }
  }

  handleCollectClk(e, { itemId, collected }) {
    // 收藏 & 取消收藏
    e.stopPropagation()

    const __collectItem = curItemId => {
      this.setState((prevState, props) => {
        let { list } = prevState
        list = list.map(item => {
          if (item.itemId === itemId) {
            item.collected = !item.collected
          }
          return item
        })
        return {
          ...prevState,
          list
        }
      })
    }

    let handleCollectApi = collected ? favService.deleteFavoriteItem : favService.addFavoriteItem

    handleCollectApi(itemId, ( { data = {} } = {}) => {
      let { isSuccess } = data
      if (true === isSuccess || 'true' === isSuccess) {
        __collectItem(itemId)
      }
    }, ({ errorCode, errorMsg }) => {
      // {'errorCode':'ERROR_CODE','errorMsg':'错误信息'}
      console.log(errorCode, errorMsg)
    })
  }

  handleOpenClk() {

    this.setState((prevState) => {
      return {
        isOpen: !prevState.isOpen
      }
    })
    /* this.props.eventDispather({
      styleType: 'type3',
      styleItem: []
    }) */
    this.exchanePanel().then(() => {
    })
  }

  handleCloseClk(isExchange = false) {
    return this.exchanePanel().then(() => {
      if (!isExchange) {
        /* this.props.eventDispather({
          styleType: 'type2',
          styleItem: []
        }) */
      }
      this.setState({
        isOpen: false
      })
    })
  }

  exchanePanel() {
    this.setState((prevState, props) => {
      return {
        activeCls: prevState.activeCls === '' ? 'active' : ''
      }
    })
    return new Promise(resolve => {
      this.refs['shoppingList'].addEventListener('webkitTransitionEnd', e => {
        resolve()
      }, false)
    })
  }

  handleTouchStart(e) {
    this.touchStartX = e.changedTouches[0].pageX
  }
  
  handleTouchMove(e) {
    this.touchEndX = e.changedTouches[0].pageX
  }

  handleTouchEnd(e) {
    let deltaX = this.touchEndX - this.touchStartX
    if (deltaX / window.innerWidth > 0.25) {
      this.handleCloseClk()
    }
  }

  render() {
    let { shoppingList, iphoneXClass } = this.props
    let { isOpen, list, animateCls, activeCls, display } = this.state

    if (!shoppingList || !shoppingList.length) return <div/>

    let listInfo = data => {
      return (
        data.map((item, index) => (
          <div className="shop item" key={item.itemId + index} onClick={() => this.goDetail(item)}>
            <div className="item-pic" style={{ backgroundImage:`url(${item.pictUrl})` }}></div>
            <div className="item-info">
              <h3 className="title">{item.title}</h3>
              <p className="item-action">
                <span className="price">￥{item.price}</span>
                {item.type === 'ANCHOR' && <span className="anchor" onClick={e => this.handleTagClk(e, item)}>看实物</span>}
                <img className="collection" src={ item.collected ? 'https://img.alicdn.com/tfs/TB165mmlxrI8KJjy0FpXXb5hVXa-48-48.png' : 'https://img.alicdn.com/tfs/TB17immlxrI8KJjy0FpXXb5hVXa-48-48.png'} alt="collection" onClick={e => this.handleCollectClk(e, item)} />
              </p>
            </div>
          </div>
        ))
      )
    }

    return (
      <div ref="shoppingList" className={`shopping-list ${animateCls} ${activeCls}`} style={{display: display }} onClick={this.handleClk}>
        <div className={ `wrapper ${iphoneXClass}` } onTouchMove={this.handleTouchMove} onTouchStart={this.handleTouchStart} onTouchEnd={this.handleTouchEnd}>
          <div className="content">
            <p className="label">场景中的商品</p>
            {listInfo(list)}
          </div>
        </div>
        <div className={`close ${activeCls}`} onClick={e => this.handleCloseClk()}></div>
        <div className="indicator" style={{display: isOpen ? 'none' : 'block'}} onClick={this.handleOpenClk}>商品 {shoppingList && shoppingList.length}</div>
      </div>
    )
  }
}

export default ShoppingList



// WEBPACK FOOTER //
// ./src/Components/Goods/index.js